import {
  type ComponentProps, forwardRef,
} from 'react';
import { TriStateRange } from '~/_shared/constants/triStateRange.enum';
import { TriStateCheckboxComponent } from './triStateCheckbox.component';

export type CheckboxComponentProps = Omit<ComponentProps<typeof TriStateCheckboxComponent>, 'checkmark'> & Readonly<{
  isChecked: boolean;
}>;

export const CheckboxComponent = forwardRef<HTMLLabelElement, CheckboxComponentProps>(
  ({ isChecked, ...props }, ref) => (
    <TriStateCheckboxComponent
      {...props}
      ref={ref}
      checkmark={isChecked ? TriStateRange.Full : TriStateRange.None}
    />
  ));

CheckboxComponent.displayName = 'CheckboxComponent';
